import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './PaxCertifiedBadge.css';

/**
 * OscAir PAX Certificated badge – pecsét a pilóta neve mellett.
 * Azt jelzi, hogy a pilóta átment a belső értékelési rendszeren, vizsgázott, vihet biztonságosan utasokat.
 */
const PaxCertifiedBadge = ({ pilotName, showTooltip = true, inline = true }) => {
  const { t } = useTranslation();
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const badge = (
    <span
      className={`pax-certified-badge ${inline ? 'pax-certified-inline' : ''}`}
      title={showTooltip ? t('paxCertified.tooltip') : undefined}
      onMouseEnter={() => showTooltip && setTooltipVisible(true)}
      onMouseLeave={() => setTooltipVisible(false)}
      aria-label={t('paxCertified.ariaLabel')}
    >
      <span className="pax-certified-seal">{t('paxCertified.seal')}</span>
      {showTooltip && tooltipVisible && (
        <span className="pax-certified-tooltip" role="tooltip">
          {t('paxCertified.tooltip')}
        </span>
      )}
    </span>
  );

  if (pilotName) {
    return (
      <span className="pax-certified-wrapper">
        <span className="pax-certified-name">{pilotName}</span>
        <span className="pax-certified-badge-row">{badge}</span>
      </span>
    );
  }

  return badge;
};

export default PaxCertifiedBadge;
